import { ODataHeader, ODataString, ODataBoolean } from "pbas-vue-components";

function getHeaders() {
  return [
    new ODataHeader({
      type: new ODataString("Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      title: "components.plancreationwizard.unique_identifier",
      type: new ODataString("UniqueIdentifier"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("Name"),
      visible: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      type: new ODataString("CurrentPlanFee/Id"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      title: "headers.plan_fees_configuration.drawbridge_services",
      type: new ODataBoolean("CurrentPlanFee/HasDrawbridgeServices"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.plan_fees_configuration.pbas_admin_services",
      type: new ODataBoolean("CurrentPlanFee/HasPBASAdminServices"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.plan_fees_configuration.pbas_account_administration",
      type: new ODataBoolean("CurrentPlanFee/HasPBASAccountAdministration"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
  ];
}

export default getHeaders;
